import { useState, FormEvent } from 'react';

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    company: '',
    phone: '',
    email: '',
    partnerType: 'agency',
    interests: [] as string[],
    expectedCustomers: '',
    notes: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const interestOptions = [
    'Tour truyền thống',
    'Tour di sản thiên nhiên',
    'Free & Easy',
    'Phượt Mỹ - Caravan',
    'Tour đường sắt',
    'Tour MICE - B2B',
    'Land tour & vận tải',
    'Du học',
    'Định cư',
    'Bất động sản'
  ];

  const handleInterestChange = (interest: string) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest]
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!formData.fullName || !formData.phone || !formData.email) {
      alert('Vui lòng điền đầy đủ thông tin bắt buộc');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('fullName', formData.fullName);
      formBody.append('company', formData.company);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('partnerType', formData.partnerType === 'agency' ? 'Đại lý phổ thông' : 'Đối tác chiến lược');
      formBody.append('interests', formData.interests.join(', '));
      formBody.append('expectedCustomers', formData.expectedCustomers);
      formBody.append('notes', formData.notes);

      const response = await fetch('https://readdy.ai/api/form/d4hs0vdtnoqs9bvm9t4g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          company: '',
          phone: '',
          email: '',
          partnerType: 'agency',
          interests: [],
          expectedCustomers: '',
          notes: ''
        });
        
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 1000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="registration-form" className="py-16 sm:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Đăng Ký Trở Thành Đối Tác
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 px-4">
            Điền thông tin để chúng tôi liên hệ và tư vấn chi tiết
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-12">
          <form id="partner-registration-form" data-readdy-form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 mb-5 sm:mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Họ và tên <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Nguyễn Văn A"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Công ty / Thương hiệu
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Công ty Du lịch ABC"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Số điện thoại / Zalo <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="0912345678"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="email@example.com"
                  required
                />
              </div>
            </div>

            <div className="mb-5 sm:mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Chọn cấp đăng ký <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <label className="relative flex items-start sm:items-center p-4 border-2 rounded-lg cursor-pointer hover:bg-blue-50 transition-colors">
                  <input
                    type="radio"
                    name="partnerType"
                    value="agency"
                    checked={formData.partnerType === 'agency'}
                    onChange={(e) => setFormData({ ...formData, partnerType: e.target.value })}
                    className="w-5 h-5 text-blue-600 cursor-pointer flex-shrink-0 mt-0.5 sm:mt-0"
                  />
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900 text-sm sm:text-base">Đại lý phổ thông</p>
                    <p className="text-xs sm:text-sm text-gray-600">Hợp tác linh hoạt, không ràng buộc</p>
                  </div>
                </label>

                <label className="relative flex items-start sm:items-center p-4 border-2 rounded-lg cursor-pointer hover:bg-orange-50 transition-colors">
                  <input
                    type="radio"
                    name="partnerType"
                    value="strategic"
                    checked={formData.partnerType === 'strategic'}
                    onChange={(e) => setFormData({ ...formData, partnerType: e.target.value })}
                    className="w-5 h-5 text-orange-600 cursor-pointer flex-shrink-0 mt-0.5 sm:mt-0"
                  />
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900 text-sm sm:text-base">Đối tác chiến lược</p>
                    <p className="text-xs sm:text-sm text-gray-600">Hợp tác sâu, quyền lợi cao nhất</p>
                  </div>
                </label>
              </div>
            </div>

            <div className="mb-5 sm:mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Mảng quan tâm (chọn nhiều)
              </label>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
                {interestOptions.map((interest) => (
                  <label key={interest} className="flex items-start cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.interests.includes(interest)}
                      onChange={() => handleInterestChange(interest)}
                      className="w-4 h-4 text-blue-600 rounded cursor-pointer mt-0.5 flex-shrink-0"
                    />
                    <span className="ml-2 text-xs sm:text-sm text-gray-700 leading-tight">{interest}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="mb-5 sm:mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Số khách dự kiến/tháng
              </label>
              <select
                name="expectedCustomers"
                value={formData.expectedCustomers}
                onChange={(e) => setFormData({ ...formData, expectedCustomers: e.target.value })}
                className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm cursor-pointer"
              >
                <option value="">Chọn số lượng khách</option>
                <option value="1-5">1-5 khách</option>
                <option value="6-10">6-10 khách</option>
                <option value="11-20">11-20 khách</option>
                <option value="21-50">21-50 khách</option>
                <option value="50+">Trên 50 khách</option>
              </select>
            </div>

            <div className="mb-6 sm:mb-8">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Ghi chú / Câu hỏi
              </label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={(e) => {
                  if (e.target.value.length <= 500) {
                    setFormData({ ...formData, notes: e.target.value });
                  }
                }}
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                placeholder="Chia sẻ thêm về nhu cầu của bạn..."
              />
              <p className="text-xs text-gray-500 mt-1 text-right">
                {formData.notes.length}/500 ký tự
              </p>
            </div>

            {submitStatus === 'success' && (
              <div className="mb-5 sm:mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-green-600 text-lg sm:text-xl flex-shrink-0"></i>
                <div>
                  <p className="font-semibold text-green-800 text-sm sm:text-base">Đăng ký thành công!</p>
                  <p className="text-xs sm:text-sm text-green-700">Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất.</p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-5 sm:mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
                <i className="ri-error-warning-fill text-red-600 text-lg sm:text-xl flex-shrink-0"></i>
                <div>
                  <p className="font-semibold text-red-800 text-sm sm:text-base">Có lỗi xảy ra!</p>
                  <p className="text-xs sm:text-sm text-red-700">Vui lòng thử lại hoặc liên hệ trực tiếp qua hotline.</p>
                </div>
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-3 sm:py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold text-sm sm:text-base md:text-lg rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Đang gửi...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-send-plane-fill"></i>
                  Đăng ký trở thành đối tác
                </span>
              )}
            </button>
          </form>
        </div>

        <div className="mt-6 sm:mt-8 text-center">
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">Hoặc liên hệ trực tiếp</p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 px-4">
            <a href="tel:0889992466" className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
              <i className="ri-phone-fill"></i>
              <span>Hotline: 088-999-2466</span>
            </a>
            <a href="mailto:info@lienminhmy.com" className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
              <i className="ri-mail-fill"></i>
              <span>info@lienminhmy.com</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}